<template>
<div id="emisores" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Emisores/Destinatarios" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel v-tippy style="cursor: pointer" title="Exportar" :data="datafiltered" :exportFields="emisores.camposexcel" name="Emisores.xlsx" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="emisores.camposLayout" :exportFields="emisores.encabezadoLayout" name="Layout Emisores Destinatarios.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{update ? "Actualizar" : "Nuevo"}}
                                                Emisor/Destinatario</strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-autocomplete v-model="model.identificador" :items="identificadorCombo" :hide-no-data="true" clearable :item-text="nombreIdentificador" item-value="id" label="Seleccione Tipo de Identificador" :rules="[rules.required]" ></v-autocomplete>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="rfc" label="RFC o TAX ID" type="text" @input="model.rfc = model.rfc.toUpperCase()" v-model="model.rfc" :rules="[rules.required, validaRfcUnico]" maxlength="20" ></v-text-field>
                                                </v-flex>                                                
                                            </v-layout>
                                            <v-row row wrap>
                                                <v-col sm="12" md="8" lg="8">
                                                    <v-text-field name="razon_social" label="Nombre o Razón Social" type="text" v-model="model.razon_social" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-col> 
                                                <v-col sm="12" md="4" lg="4">
                                                    <v-radio-group v-model="model.tipo_persona" :rules="[rules.required]">
                                                        <template v-slot:label>
                                                            <div><strong>Tipo de Persona:</strong></div>
                                                        </template>
                                                        <v-radio label="Persona Física" value="fisica" ></v-radio>
                                                        <v-radio label="Persona Moral" value="moral" ></v-radio>
                                                    </v-radio-group>
                                                </v-col>                                                
                                            </v-row>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="nombre_contacto" label="Nombre Contacto" type="text" v-model="model.nombre_contacto" maxlength="50" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="telefono_contacto" label="Teléfono" type="text" v-model="model.telefono_contacto" maxlength="18" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="email_contacto" label="Email" type="email" v-model="model.email_contacto" :rules="[rules.email]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="calle" label="Calle" type="text" v-model="model.calle" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field name="numero_exterior" label="No. Exterior" type="text" v-model="model.numero_exterior" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field name="numero_interior" label="No. Interior" type="text" v-model="model.numero_interior" maxlength="10" ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex s12 m2 l2>
                                                    <v-text-field name="codigo_postal" label="C.P." type="text" v-model="model.codigo_postal" maxlength="12" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="colonia" label="Colonia" type="text" v-model="model.colonia" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="referencia" label="Referencia" type="text" v-model="model.referencia" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex s12>
                                                    <v-autocomplete v-model="model.pais" :items="paisesCombo" :hide-no-data="true" clearable :item-text="nombrePais" item-value="id_pais" label="Selecciona un País" @input="cargarEstados(1)" :rules="[rules.required]" ></v-autocomplete>
                                                </v-flex>
                                                <v-flex s12>
                                                    <v-autocomplete v-model="model.estado" :items="estadosCombo" :hide-no-data="true" clearable :item-text="nombreEstado" item-value="id_estado" label="Selecciona un Estado" @input="cargarCiudadesMunicipios(1)" :loading="loadingEstado" ></v-autocomplete>
                                                </v-flex>
                                                <v-flex s12>
                                                    <v-autocomplete v-model="model.ciudad" :items="ciudadesCombo" :hide-no-data="true" clearable :item-text="nombreCiudad" item-value="descripcion" label="Selecciona una Ciudad" :loading="loadingCiudad" ></v-autocomplete>
                                                </v-flex>
                                                <v-flex s12>
                                                    <v-autocomplete v-model="model.municipio" :items="municipiosCombo" :hide-no-data="true" clearable :item-text="nombreMunicipio" item-value="descripcion" label="Selecciona un Municipio" :loading="loadingMunicipio" ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field name="metadato" label="Metadato" type="text" v-model="model.metadato" :rules="[rules.required]" maxlength="150" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-checkbox v-model="model.existe_vinculacion" label="Si existe vinculación" :true-value="1" :false-value="0"></v-checkbox>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-checkbox v-model="model.iat" label="IAT" :true-value="1" :false-value="0"></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <v-autocomplete :items="tiposDocumentos" v-model="model.tipo_documento" label="Tipo Documento" :item-text="getNombreTipo" item-value="clave" :rules="[]" ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="emisores.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_emisor_destinatario)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_emisor_destinatario)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";
import ComboPaises from '@/components/ComboPaises/index.vue';

export default {
    components: {
        "v-combo-paises": ComboPaises,
    },
    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],
        columns: ["rfc", "razon_social", "existe_vinculacion", "pais.nombre","metadato", "actions"],
        show_loading: true,
        options: {
            filterable: ["rfc", "razon_social", "existe_vinculacion", "pais.nombre","metadato"],
            sortable: ["rfc", "razon_social", "existe_vinculacion", "pais.nombre","metadato"],

            headings: {
                rfc: "RFC o TAX ID",
                razon_social: "Nombre o Razón Social",
                existe_vinculacion: "Tipo Vinculación",
                telefono_contacto: " Telefono contacto",
                email_contacto: "Email contacto",
                calle: "Calle",
                numero_exterior: "Num. Exterior",
                numero_interior: "Num. Interior",
                colonia: "Colonia",
                codigo_postal: "CP",
                ciudad: "Ciudad",
                municipio: "Municipio",
                referencia: "Referencias",
                estado: "Estado",
                "pais.nombre": "País",
                metadato: "Metadato",
                actions: "Operaciones"
            }
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Emisores/Destinatarios",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        rfcupdate: "",
        tiposDocumentos:[],
        identificadorCombo: [],
        paisesCombo: [],
        estadosCombo: [],
        ciudadesCombo: [],
        municipiosCombo: [],
        loadingEstado: false,
        loadingCiudad: false,
        loadingMunicipio: false,
        
        model: {
            id_emisor_destinatario: 0,
            rfc: "",
            razon_social: "",
            nombre_contacto: "",
            telefono_contacto: "",
            email_contacto: "",
            calle: "",
            numero_exterior: "",
            numero_interior: "",
            colonia: "",
            codigo_postal: "",
            ciudad: "",
            municipio: "",
            referencia: "",
            estado: "",
            pais: "",
            cliente: "",
            metadato: "",
            existe_vinculacion:0,
            iat:0,
            tipo_persona: "",
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                if (value) {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                } else return true;
            },
            rfclen: v => (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres",
        },
        paises: [0],
        estados: {
            todos: [0],
            filtrados: [0]
        },

        emisores: {
            selected: [],
            headers: [{
                    text: "RFC o TAX ID",
                    value: "rfc"
                },
                {
                    text: "Razón Social",
                    value: "razon_social"
                },
                {
                    text: "Contacto",
                    value: "nombre_contacto"
                },
                {
                    text: "Teléfono",
                    value: "telefono_contacto"
                },
                {
                    text: "Metadato",
                    value: "metadato"
                },
                {
                    text: "Operaciones",
                    value: "operaciones",
                    align: "center"
                }
            ],
            camposexcel: {
                RFC: "rfc",
                "Nombre o Razón Social": "razon_social",
                "Tipo Persona": "tipo_persona",
                Contacto: "nombre_contacto",
                "Teléfono": "telefono_contacto",
                Email: "email_contacto",
                Calle: "calle",
                "Número Exterior": "numero_exterior",
                "Número Interior": "numero_interior",
                Colonia: "colonia",
                CP: "codigo_postal",
                Referencia: "referencia",
                Ciudad: "ciudad",
                Municipio: "municipio",
                Estado: "estado.nombre",
                "País": "pais.nombre",
                Metadato: "metadato",
                "Si existe vinculación": "existe_vinculacion",
                "IAT":"iat"                
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                rfc: "rfc",
                razon_social: "razon_social",
                tipo_persona: "tipo_persona",
                nombre_contacto: "nombre_contacto",
                telefono_contacto: "telefono_contacto",
                email_contacto: "email_contacto",
                calle: "calle",
                numero_exterior: "numero_exterior",
                numero_interior: "numero_interior",
                colonia: "colonia",
                codigo_postal: "codigo_postal",
                referencia: "referencia",
                ciudad: "ciudad",
                municipio: "municipio",
                estado: "estado",
                pais: "pais",
                metadato: "metadato",
                "existe_vinculacion":"existe_vinculacion",
                "iat":"iat"
            },
            camposLayout: [{
                rfc: "[RFC del Emisor/destinatario - Obligatorio]",
                razon_social: "[Nombre o Razón Social - Obligatorio]",
                tipo_persona: "[fisica o moral - Obligatorio]",
                nombre_contacto: "[Opcional]",
                telefono_contacto: "[Opcional]",
                email_contacto: "[Opcional]",
                calle: "[Nombre de la calle - Obligatorio]",
                numero_exterior: "[No. Exterior - Obligatorio]",
                numero_interior: "[Opcional]",
                colonia: "[Opcional]",
                codigo_postal: "[Opcional]",
                referencia: "[Opcional]",
                ciudad: "[Clave de Ciudad - Opcional]",
                municipio: "[Clave de Municipio - Opcional]",
                estado: "[Clave del Estado - Opcional]",
                pais: "[Clave del País - Obligatorio]",
                metadato: "[Metadato - Obligatorio]",
                "existe_vinculacion":"[Solo se permite el 1 o el 0 (1-Si, 0-No) - Obligatorio]",
                "iat":"[Solo se permite el 1 o el 0 (1-Si, 0-No)]"
            }]
        },

        camposObligatorios: [
            "rfc",
            "razon_social",
            "tipo_persona",
            "calle",
            "numero_exterior",            
            "pais",
            "metadato",
            "existe_vinculacion"
        ],

    }),
    computed: {
        datafiltered() {
            if (this.$refs.vuetable != null) {
                return this.$refs.vuetable.allFilteredData;
            } else {
                return this.emisores.items;
            }

        },
    },
    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Emisor/Destinatario";
                this.update = false;
            } else {
                this.title = "Actualizar Emisor/Destinatario";
                this.update = true;
                this.rfcupdate = this.model.rfc;
            }
            this.modal = true;
        },

        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },

        validaRfcUnico: function (rfc_value) {
            if (rfc_value!=null && rfc_value!=''){
                var rfcs = this.emisores.items.map(function (item) {
                    return item.rfc
                });
                var finder = rfcs.indexOf(rfc_value);

                if (finder != -1 && ((this.update == false) || (this.update == true && this.rfcupdate != rfc_value)))
                    return "El RFC/TAX ID ya ha sido ingresado";
                else
                    return true;
            } else
                return true;
        },
        getTiposDocumentos: function () {

            var data = {
                tabla: 25,
            };
            axios.post(this.$hostname + "apendices/lista/", data)
                .then(response => {
                    if (response.data != undefined) {
                        this.tiposDocumentos = response.data;
                        this.tiposDocumentos = this.tiposDocumentos.sort(function (a, b) {
                            return a.clave > b.clave;
                        });

                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de documento.",
                        footer: ""
                    });
                });
        },
        getNombreTipo: function (val) {
            return val.clave + " - " + val.descripcion;
        },

        guardar() {
            const datos = this.model;
            if(datos["existe_vinculacion"]!= undefined && datos["existe_vinculacion"]==""){
                datos["existe_vinculacion"]= 0;
            }
            if(datos["iat"]!= undefined && datos["iat"]==""){
                datos["iat"]= 0;
            }

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;

                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_emisor_destinatario + "/";
                }
                
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "get_emisores/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores.items = res.data;   
                        
                        for(var k in this.emisores.items){
                            this.emisores.items[k].existe_vinculacion = this.emisores.items[k].existe_vinculacion==1?'Si':'No';
                        }                     
                    }
                })
                .catch(err => {
                   
                    console.log(err);                    
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        },

        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.filtrar_estados(2);
                    if (this.model.pais!= undefined && this.model.pais!="")
                        this.cargarEstados(2);
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            //position: 'bottom-end',
                            //timer: 3000,
                            //showConfirmButton: false,
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    });
                }
                    
            });
        }, //delete
        llenar_selects: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(response => {
                    this.paises = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los paises.",
                        footer: ""
                    });
                });

            axios
                .get(this.$hostname + "estados/")
                .then(response => {
                    this.estados.todos = this.estados.filtrados = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los estados.",
                        footer: ""
                    });
                });
        },
        filtrar_estados: function (opcion) {
            if (opcion == 1)
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.model.estado = "";
            let pais = this.model.pais;
            let datos = this.estados.todos.filter(item => {
                return item.pais == pais;
            });
            this.estados.filtrados = datos;
        },
        verificaPaisesVacios: function (clave_pais, clave_estado, clave_ciudad, clave_municipio) {
            var erroresText = '';
            if (clave_municipio != undefined && clave_estado == undefined)
                erroresText += "- La clave municipio \"" + clave_municipio + "\" no debe tener el estado vacío.<br>";
            if (clave_ciudad != undefined && clave_estado == undefined)
                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no debe tener el estado vacío.<br>";
            if (clave_estado != undefined && clave_pais == undefined)
                erroresText += "- La clave estado \"" + clave_estado + "\" no debe tener el país vacío.<br>";
            return erroresText;

        },
        verificaComboPaises: async function (clave_pais, clave_estado, clave_ciudad, clave_municipio) {
            var erroresText = '';
            let verificaP = await this.verificaPais(clave_pais, '');
            if (verificaP == 0) {
                erroresText += "- La clave país \"" + clave_pais + "\" no existe en el sistema.<br>";
            } else {
                let id_pais = await this.verificaPais(clave_pais, 'id');
                if (clave_estado != undefined) {
                    let verificaE = await this.verificaEstado(clave_estado, id_pais, '');
                    if (verificaE == 0) {
                        erroresText += "- La clave estado \"" + clave_estado + "\" no pertenece al país \"" + clave_pais + "\".<br>";
                    } else {
                        let id_estado = await this.verificaEstado(clave_estado, id_pais, 'id');
                        if (clave_ciudad != undefined) {
                            let verificaC = await this.verificaCiudad(clave_ciudad, id_pais, id_estado, '');
                            if (verificaC == 0)
                                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no pertenece al estado \"" + clave_estado + "\".<br>";
                        }
                        if (clave_municipio != undefined) {
                            let verificaM = await this.verificaMunicipio(clave_municipio, id_pais, id_estado, '');
                            if (verificaM == 0)
                                erroresText += "- La clave municipio \"" + clave_municipio + "\" no pertenece al estado \"" + clave_estado + "\".<br>";
                        }
                    }
                }

            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined)
                    resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return e.clave_m3.toString().trim().toLowerCase() == clave_pais.toString().trim().toLowerCase();
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_pais : '');
                else
                    resolve(search.length);
            });

        },
        verificaEstado: function (clave_estado, id_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_estado == undefined)
                    resolve(0);

                var search = thisObject.estados.todos.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == clave_estado.toString().trim().toLowerCase() &&
                        e.pais == id_pais;
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_estado : '');
                else
                    resolve(search.length);
            });
        },
        verificaCiudad: function (clave_ciudad, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_ciudad == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/ciudades/get_ciudades/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            thisObject.ciudades = res.data;
                            var search = thisObject.ciudades.filter(function (e) {
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_ciudad.toString().trim())) || (e.clave.toString().trim() == clave_ciudad.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },
        verificaMunicipio: function (clave_municipio, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_municipio == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/municipios/get_municipios/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            thisObject.municipios = res.data;
                            var search = thisObject.municipios.filter(function (e) {
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_municipio.toString().trim())) || (e.clave.toString().trim() == clave_municipio.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }
            this.camposObligatorios.forEach(function (campo) {
                if (keys.indexOf(campo) == -1)
                    errores += '<br/>' + "- El campo '" + campo + "' es obligatorio.";
            });

            return errores == '' ? true : errores;
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var erroresText = '';
            try {
                if (results.length == 0) {
                    errores++;
                    erroresText += "No hay datos en el layout. Verifique que exista información a partir del 3er renglón.";
                } else {
                    for (var k in results) {
                        results[k]["user_updated"] = thisObject.$local_storage.get("email");
                        results[k]["cliente"] = thisObject.$local_storage.get("id_cliente");
                        var obligatorios = this.verificaObligatorios(results[k]);
                        if (obligatorios !== true) {
                            errores++;
                            if (erroresText.indexOf(obligatorios) == -1)
                                erroresText += obligatorios;
                        } else {

                            if(![1,0].includes(results[k]["existe_vinculacion"])){
                                errores++;
                                erroresText += "- existe_vinculacion \"" + results[k]["existe_vinculacion"] + "\" solo permite 1 o 0.<br>";
                            }

                            if(results[k]["iat"]!=undefined && ![1,0].includes(results[k]["iat"])){
                                errores++;
                                erroresText += "- iat \"" + results[k]["iat"] + "\" solo permite 1 o 0.<br>";
                            }

                            if(!["fisica","moral"].includes(results[k]["tipo_persona"])){
                                errores++;
                                erroresText += "- tipo_persona \"" + results[k]["tipo_persona"] + "\" solo permite 'fisica' o 'moral'.<br>";
                            }

                            let clavesVaciasAgente = thisObject.verificaPaisesVacios(results[k]["pais"], results[k]["estado"], results[k]["ciudad"], results[k]["municipio"]);
                            if (clavesVaciasAgente.toString().trim().length > 0) {
                                errores++;
                                if (erroresText.indexOf(clavesVaciasAgente) == -1)
                                    erroresText += clavesVaciasAgente;
                            } else {
                                if (results[k]["pais"] != undefined) {
                                    let verificaAgentePaises = await thisObject.verificaComboPaises(results[k]["pais"], results[k]["estado"], results[k]["ciudad"], results[k]["municipio"]);
                                    if (verificaAgentePaises.toString().trim().length > 0) {
                                        errores++;
                                        if (erroresText.indexOf(verificaAgentePaises) == -1)
                                            erroresText += verificaAgentePaises;
                                    }
                                }
                                if (results[k]["codigo_postal"] == undefined){
                                    results[k]["codigo_postal"]="";
                                }
                            }

                        }
                        //console.log("Key is " + k + ", value is" + results[k]);
                    }

                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    for (var k in results) {

                        var id_pais = results[k]["pais"] != undefined ? await this.verificaPais(results[k]["pais"], 'id') : '';
                        if (id_pais != '')
                            var id_estado = results[k]["estado"] != undefined ? await this.verificaEstado(results[k]["estado"], id_pais, 'id') : '';
                        else
                            var id_estado = '';

                        this.importData.push({
                            razon_social: results[k]["razon_social"],
                            tipo_persona: results[k]["tipo_persona"],
                            rfc: results[k]["rfc"],
                            nombre_contacto: results[k]["nombre_contacto"],
                            telefono_contacto: results[k]["telefono_contacto"],
                            email_contacto: results[k]["email_contacto"],
                            calle: results[k]["calle"],
                            numero_exterior: results[k]["numero_exterior"],
                            numero_interior: results[k]["numero_interior"],
                            colonia: results[k]["colonia"],
                            codigo_postal: results[k]["codigo_postal"],
                            referencia: results[k]["referencia"],
                            ciudad: results[k]["ciudad"] != undefined ? await this.verificaCiudad(results[k]["ciudad"], id_pais, id_estado, 'id') : '',
                            municipio: results[k]["municipio"] != undefined ? await this.verificaMunicipio(results[k]["municipio"], id_pais, id_estado, 'id') : '',
                            estado: id_estado,
                            pais: id_pais,
                            metadato: results[k]["metadato"],
                            existe_vinculacion: results[k]["existe_vinculacion"],
                            iat: results[k]["iat"],
                            cliente: results[k]["cliente"],
                            user_updated: results[k]["user_updated"],
                        });

                    }

                    await axios.post(this.URL + "importar_emisores/", this.importData)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];
                                            if (key != 'contactos' && key != 'domicilios') { //Este trae 2 niveles, por eso el campo queda en la key2
                                                Object.keys(errors).forEach(function (key2) {
                                                    let pos = errores.indexOf(key + ": " + errors[key2]);
                                                    if (pos < 0) {
                                                        errores += key + ": " + errors[key2];
                                                        errores += "<br>";
                                                    }
                                                });
                                            } else { //contactos y domicilios, traen 3 niveles, por eso el campo queda en la key3
                                                Object.keys(errors).forEach(function (key2) {
                                                    Object.keys(errors[key2]).forEach(function (key3) {
                                                        let pos = errores.indexOf(key3 + ": " + errors[key2][key3]);
                                                        if (pos < 0) {
                                                            errores += key3 + ": " + errors[key2][key3];
                                                            errores += "<br>";
                                                        }

                                                    });
                                                });
                                            }

                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();                            
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        nombreIdentificador: function (identificador) {
            return (identificador != undefined) ? identificador.clave + " - " + identificador.descripcion : '';
        },
        nombrePais: function (pais) {
            return (pais != undefined) ? pais.clave_m3 + " - " + pais.nombre : '';
        },
        nombreEstado: function (estado) {
            return (estado != undefined) ? estado.clave + " - " + estado.nombre : '';
        },
        nombreCiudad: function (ciudad) {
            return (ciudad != undefined) ? ciudad.clave + " - " + ciudad.descripcion : '';
        },
        nombreMunicipio: function (municipio) {
            return (municipio != undefined) ? municipio.clave + " - " + municipio.descripcion : '';
        },
        cargarIdentificadores: function () {
            axios
                .get(this.$hostname + "catalogos/vucem_identificadores/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.identificadorCombo = res.data;                                                
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de Vucem Identificadores",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de Vucem Identificadores.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.paisesCombo = res.data;                        
                        if (this.model.pais != "")
                            this.cargarEstados(2);
                    } else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarEstados: function (opcion) {
            if (opcion == 1) {
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.model.estado = "";
                this.model.ciudad = "";
                this.model.municipio = "";
            }
            var id_pais = "";                        
            id_pais = this.model.pais;             

            if (id_pais != ""){
                this.loadingEstado = true;
                axios
                    .post(this.$hostname + "estados/get_estados_pais/", {
                        pais: id_pais
                    })
                    .then(res => { 
                        if (typeof res.data !== "undefined") {
                            this.estadosCombo = res.data;
                            if (this.model.estado != "")
                                this.cargarCiudadesMunicipios(2);
                            else
                                this.cargarCiudadesMunicipios(1);
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los estados asociados al país seleccionado.",
                            footer: ""
                        });
                        console.log(err);
                    }).then(() => {
                        this.loadingEstado = false;
                    });
            }
        },

        cargarCiudadesMunicipios: function (opcion) {
            if (opcion == 1) {
                //1-Limpiar ciudad,municipio seleccionado, 2-No limpiar
                this.model.ciudad = "";
                this.model.municipio = "";
            }
            
            var id_pais = this.model.pais!= undefined ? this.model.pais : "";
            var id_estado = this.model.estado!= undefined ? this.model.estado : "";            
            
            if (id_pais !="") {
                this.loadingCiudad = true;
                axios
                    .post(this.$hostname + "catalogos/ciudades/get_ciudades/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.ciudadesCombo = res.data;
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener las ciudades asociados al estado seleccionado.",
                        });
                        console.log(err);
                    }).then(() => {
                        this.loadingCiudad = false;
                        this.cargarMunicipios();
                    });
            }
        },

        cargarMunicipios: function () {            
            var id_pais = this.model.pais!= undefined ? this.model.pais : "";
            var id_estado = this.model.estado!= undefined ? this.model.estado : "";

            if (id_pais!=""){
                this.loadingMunicipio = true;
                axios
                    .post(this.$hostname + "catalogos/municipios/get_municipios/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.municipiosCombo = res.data;
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los municipios asociados al estado seleccionado.",
                        });
                        console.log(err);
                    }).then(() => {
                        this.loadingMunicipio = false;
                    });
            }

        },
    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/emisores_destinatarios/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();
        this.getTiposDocumentos();
        this.cargarPaises();
        this.cargarIdentificadores();
        this.llenar_selects();
       
    }
};
</script>
